import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { MatChipsModule } from '@angular/material/chips';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CdkTableModule } from '@angular/cdk/table';

const modules = [BrowserAnimationsModule,
	MatToolbarModule,
	MatIconModule,
	MatButtonModule,
	MatCardModule,
	MatProgressSpinnerModule,
	MatSidenavModule,
	MatCheckboxModule,
	MatListModule,
	MatExpansionModule,
	MatSlideToggleModule,
	MatFormFieldModule,
	MatDialogModule,
	MatChipsModule,
	MatTabsModule,
	MatSelectModule,
	MatFormFieldModule,
	MatInputModule,
	MatAutocompleteModule,
	MatPaginatorModule,
	MatTooltipModule,
	MatGridListModule,
	MatMenuModule,
	MatProgressSpinnerModule,
	MatTableModule,
	MatSortModule,
	MatDatepickerModule,
	MatNativeDateModule,
	MatProgressBarModule,
	MatSnackBarModule,
	CdkTableModule
];

@NgModule({
	imports: [CommonModule, ...modules],
	exports: [...modules],
})
export class MaterialDesignModule { }
